// Central configuration for all site data
export const siteConfig = {
  // Personal Information
  name: "Cary Schweitzer",
  title: "Apps to solve everyday problems.",
  
  // API Endpoints
  formspreeEndpoint: "https://formspree.io/f/xvgbrrar",
  
  // Social Media Links (update once, used everywhere)
  socialLinks: {
    twitter: "https://x.com/all2neat",
    bluesky: "https://bsky.app/profile/caryschweitzer.bsky.social"
  },

  // Navigation Links
  navLinks: [
    { path: "/", label: "Home" },
    { path: "/water-track", label: "Water Track" },
    { path: "/family-budget", label: "Family Budget" },
    { path: "/contact", label: "Contact" }
  ],

  // Apps Data
  apps: [
    {
      id: "water-track",
      title: "Water Track Daily H2O",
      description: "Created a mobile application to help users track their daily water intake.",
      icon: "fas fa-tint",
      tags: ["iOS", "Android", "Coming Soon", "iOS Test Flight"],
      aboutLink: "/water-track",
      privacyLink: "/water-track-privacy",
      tosLink: "/water-track-tos",
      storeUrls: {
        ios: "https://apps.apple.com/us/app/water-track-daily-h20/id6751860160",
        android: "/android" // Replace with actual Google Play URL
      },
      storeVisibility: {
        ios: true,
        android: false
      },
      features: [
        {
          title: "Easy Water Logging",
          description: "Quickly log your water intake with just a few taps. Track different container sizes and custom amounts.",
          icon: "fas fa-plus-circle"
        },
        {
          title: "Daily Progress Tracking",
          description: "Visual progress indicators show your daily hydration goals and achievements at a glance.",
          icon: "fas fa-chart-line"
        },
        {
          title: "Smart Reminders",
          description: "Customizable reminders help you stay on track with your hydration goals throughout the day.",
          icon: "fas fa-bell"
        },
        {
          title: "Historical Data",
          description: "View your hydration patterns over time with detailed history and trend analysis.",
          icon: "fas fa-calendar-alt"
        },
        {
          title: "Personalized Goals",
          description: "Set custom daily water intake goals based on your weight, activity level, and climate.",
          icon: "fas fa-cog"
        },
        {
          title: "Cross-Platform",
          description: "Available on both iOS and Android devices with a consistent, native-feeling experience.",
          icon: "fas fa-mobile-alt"
        }
      ],
      techStack: [
        "Flutter",
        "Dart", 
        "iOS",
        "Android",
        "SQLite"
      ]
    },
    {
      id: "family-budget",
      title: "Family Budget",
      description: "Created a web application to help users track their budget so they can attempt to save money.",
      icon: "fas fa-wallet",
      tags: ["iOS", "Android", "Coming Soon"],
      aboutLink: "/family-budget",
      privacyLink: "/family-budget-privacy",
      tosLink: "/family-budget-tos",
      storeUrls: {
        ios: "https://apps.apple.com/us/app/family-budget-monthly-budget/id6751817678",
        android: "/android" // Replace with actual Google Play URL
      },
      storeVisibility: {
        ios: true,
        android: false
      },
      features: [
        {
          title: "Expense Tracking",
          description: "Easily log and categorize your daily expenses with custom categories and tags for better organization.",
          icon: "fas fa-plus-circle"
        },
        {
          title: "Budget Categories",
          description: "Create and manage budget categories for different spending areas like groceries, entertainment, and utilities.",
          icon: "fas fa-chart-pie"
        },
        {
          title: "Financial Goals",
          description: "Set and track financial goals like saving for a vacation, emergency fund, or debt repayment.",
          icon: "fas fa-bullseye"
        },
        {
          title: "Spending Analytics",
          description: "Visual charts and reports help you understand your spending patterns and identify areas for improvement.",
          icon: "fas fa-chart-line"
        },
        {
          title: "Budget Alerts",
          description: "Receive notifications when you're approaching budget limits or when bills are due.",
          icon: "fas fa-bell"
        },
        {
          title: "Family Sharing",
          description: "Share budgets and expenses with family members for better financial transparency and collaboration.",
          icon: "fas fa-users"
        }
      ],
      techStack: [
        "Flutter",
        "Dart",
        "iOS", 
        "Android",
        "SQLite"
      ]
    }
  ],

 
  // Hero Section Content
  hero: {
    title: "Hi, I'm Cary,",
    subtitle: "This is a portfolio of my apps.",
    description: "I create mobile apps that solve everyday problems. My focus is on building simple, intuitive applications that help people improve their daily lives through better habits and organization."
  },

};

export default siteConfig;
